import { combineReducers } from 'redux';
import jobsReducer from './jobs.reducer';
import updateJobReducer from './update.reducer';
import jobsUploadsReducer from './uploads.reducer';
import rowsReducer from './rows.reducer';
import jobsSearchReducer from './search.reducer';

export default combineReducers({
  jobs: jobsReducer,
  search: jobsSearchReducer,
  updateJob: updateJobReducer,
  uploads: jobsUploadsReducer,
  rows: rowsReducer,
});
